
import { getDatePickerDate } from '../Helper/DatePicker/DateConverter';
import { SET_PRIMARY_GRANULARITY, SET_SECONDARY_GRANULARITY, SET_CURRENT_DATES,  RESET_DIGITAL_TWIN_STATE } from '../Redux/DigitalTwin/types';

const defaultStartDate = getDatePickerDate(undefined, 0);
const defaultEndDate = getDatePickerDate(undefined, 0);

const initialState = {
    primaryGranularity: 'raw',
    secondaryGranularity: 'avg',
    currentDates: {
        startDate: defaultStartDate,
        endDate: defaultEndDate
    }
};

const digitalTwinReducer = (state = initialState, action) => {
    switch (action.type) {
        case SET_PRIMARY_GRANULARITY:
            return {
                ...state,
                primaryGranularity: action.payload
            };

        case SET_SECONDARY_GRANULARITY:
            return {
                ...state,
                secondaryGranularity: action.payload
            };

        case SET_CURRENT_DATES:
            return {
                ...state,
                currentDates: action.payload
            };

        case RESET_DIGITAL_TWIN_STATE:
            return initialState;

        default:
            return state;
    }
};

export default digitalTwinReducer; 